module.exports = __webpack_public_path__ + "static/homepage-our-expertise.a9b09240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage-our-expertise.jpg
// module id = 508
// module chunks = 35783957827783